<template>
    <td-dialog :title="$t(title)" :before-close="dialogLeaveBillClose" :visible.sync="dialogLeaveBillVisible" width="1000px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-container>
            <el-header style="height:100%">
                <el-form :inline="true" :model="leavelBill" ref="leavelBill" class="demo-form-inline" :rules="rules" label-width="90px">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item :label="$t('pgCommon.WORK_FLOW_CAPTION')" prop="message1">
                                <td-select :options="leaveBillTypeList" v-model="leavelBill.proDefKey" keys="templateKey" text="templateName" :disabled="isEdit" ref="message1"></td-select>
                            </el-form-item>
                            <el-form-item :label="$t('pgCommon.DISPOSE_PERSON')" prop="userId">
                                <td-input v-model="leavelBill.userId" maxlength="20" :disabled="true"></td-input>
                            </el-form-item>
                            <el-form-item :label="$t('pgCommon.APPLICANT')" prop="applyUserId">
                                <td-input v-model="leavelBill.applyUserId" :disabled="true" maxlength="20"></td-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('pgCommon.START_TIME')" prop="startTime">
                                <td-date-time v-model="leavelBill.startTime" :disabled="isEdit"></td-date-time>
                            </el-form-item>
                            <el-form-item :label="$t('pgCommon.END_TIME')" prop="endTime">
                                <td-date-time v-model="leavelBill.endTime" :disabled="isEdit"></td-date-time>
                            </el-form-item>
                            <!-- <el-form-item :label="$t('pgCommon.USE_TIME')" prop="days">
                                <td-input v-model="leavelBill.days" maxlength="3" :disabled="isEdit"></td-input>
                            </el-form-item> -->
                            <el-form-item :label="$t('pgCommon.USE_TIME')" prop="days">
                                <td-input-number v-model="leavelBill.days" :min="0" :max="999" disabled="isEdit"></td-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('pgCommon.APPLICATE_DEP')" prop="userDep">
                                <td-input v-model="leavelBill.userDep" :disabled="isEdit" maxlength="20"></td-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('pgCommon.APPLICANT_REASON')" prop="leaveReason">
                                <td-input type="textarea" v-model="leavelBill.leaveReason" width="758" :rows="4" :disabled="isEdit" maxlength="200"></td-input>
                            </el-form-item>
                            <el-form-item :label="$t('pgCommon.COMMENT')" prop="comment">
                                <td-input type="textarea" v-model="leavelBill.comment" width="758" :rows="4" :disabled="commentEdit" maxlength="200"></td-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- <span slot="footer" style="text-align:left"> -->

                    <!-- </span> -->
                </el-form>
            </el-header>
        </el-container>
        <span slot="footer" style="text-align:left" v-show="btnShow">
            <td-button type="button" v-show="submitShow" :loading="loading" @click="btnSubmit()">{{ $t('pgCommon.SUBMIT') }}</td-button>
            <!-- <td-button type="button" :disabled="toOtherShow" :loading="loading" @click="toOtherPer">{{ $t('递转') }}</td-button> -->
            <td-button type="button" v-show="rejectShow" :loading="loading" @click="reject()">{{ $t('pgCommon.REMOVE') }}</td-button>
            <td-button type="button" v-show="returnShow" :loading="loading" @click="btnReturn()">{{ $t('pgCommon.RETURN') }}</td-button>
            <td-button type="button" @click="dialogLeaveBillClose">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
        <td-table
            :columns="columns"
            :permissions="permissionsView"
            ref="leaveBill"
            :hasPage="false"
            :hasMutiSelect="false"
            :dataSource="tableData"
            :pageSize="pageSize"
            :currentPage="currentPage"
            :total="total"
            :rowKey="rowKey"
            @handleSizeChange="handleSizeChange"
            @currentChange="currentChange"
        ></td-table>
    </td-dialog>
</template>
<script>
import Api from '../assets/api.js';
export default {
    props: ['title', 'dialogLeaveBillVisible', 'editItem', 'sIdDisabled'],
    created() {
        this.initSelect();
        this.btnQuery();
    },
    mounted() {
        //加载的时候执行
        // if(this.editItem.taskDefinitionKey == 't1'){
        // }else if(this.editItem.taskDefinitionKey == 't2'){}
        // else if(this.editItem.taskDefinitionKey == 't3'){}
    },
    // 定义变量
    data() {
        return {
            //表单信息
            leavelBill: {
                proInsId: this.editItem.processId,
                proDefKey: '',
                proDefName: '',
                taskId: this.editItem.taskId,
                taskDefKey: this.editItem.taskKey,
                leaveBillType: '',
                startTime: '',
                endTime: '',
                days: '',
                leaveReason: '',
                applyUserId: this.editItem.applyUserId,
                userId: sessionStorage.getItem('userId'),
                userName: '',
                taskName: this.editItem.name,
                isPass: false,
                comment: ''
            },
            submitShow: true,
            toOtherShow: false,
            rejectShow: false,
            returnShow: false,
            operEdit: false,
            btnShow: true,
            userIdEdit: false,
            isEdit: true,
            commentEdit: false,
            currPerson: sessionStorage.getItem('userId'),
            currPerName: sessionStorage.getItem('username'),
            loading: false, // 按钮是否为加载状态
            // 请假类型
            leaveBillTypeList: [],
            // 人员列表
            userIdList: [],
            group: '',
            rules: {
                // userId: [
                //     {
                //         pattern: this.$regex.USERCAPTION_RULE,
                //         message: this.$t('pgError.ERROR_APPLICANT_CAPTION_ILLEGAL')
                //     }
                // ],
                // message1: [{ required: true, message: this.$t('pgError.ERROR_REASON_NULL'), trigger: 'blur' }]
            },
            permissionsView: ['workflow:view'],
            permissionsEdit: ['workflow:edit'],
            permissionsAdd: ['workflow:add'],
            tableData: [],
            rowKey: 'taskId',
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            columns: [
                {
                    prop: 'taskKey',
                    align: 'center',
                    label: this.$t('pgCommon.TASK_KEY')
                },
                {
                    prop: 'taskName',
                    align: 'center',
                    label: this.$t('pgCommon.TASK_NAME')
                },
                {
                    prop: 'assignee',
                    align: 'center',
                    label: this.$t('pgCommon.DISPOSE_PERSON')
                },
                {
                    prop: 'comment',
                    label: this.$t('pgCommon.COMMENT'),
                    align: 'center'
                },
                {
                    prop: 'completeTime',
                    label: this.$t('pgCommon.COMPLETED_TIME'),
                    align: 'center'
                }
            ]
        };
    },
    // 定义并实现方法体
    methods: {
        btnSubmit() {
            this.loading = true;
            this.leavelBill.isPass = true;
            this.leavelBill.userId = sessionStorage.getItem('userId');
            let param = this.leavelBill;
            // if (this.leavelBill.taskDefKey != 'check1' || this.leavelBill.taskDefKey != 'check2') {
            //     param.comment = '';
            // }
            Api.completeOrRefuse(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    return;
                }
                this.loading = false;
                if (response.data.content.length > 0) {
                    this.leavelBill.taskId = response.data.content[0].taskId;
                }
                if ('check2' === this.leavelBill.taskDefKey) {
                    //---------------------code
                    this.submitShow = false;
                    this.rejectShow = false;
                    this.returnShow = false;
                    this.commentEdit = true;
                } else if ('check1' === this.leavelBill.taskDefKey) {
                    //---------------------code
                    this.submitShow = false;
                    this.rejectShow = false;
                    this.returnShow = false;
                    this.commentEdit = true;
                } else if ('HR' === this.leavelBill.taskDefKey) {
                    //---------------------code
                    this.submitShow = false;
                    this.rejectShow = false;
                    this.returnShow = false;
                    this.commentEdit = true;
                } else if ('apply' === this.leavelBill.taskDefKey) {
                    //---------------------code
                    this.submitShow = false;
                    this.rejectShow = true;
                    this.returnShow = false;
                    this.commentEdit = true;
                }
                this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.SUBMIT_SUCCESS') });
            });
        },
        btnQuery() {
            let param = {
                proInsId: this.editItem.processId
            };
            Api.queryLeaveBillByCode(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('/device/saveDevice', response.data.statusMessage);
                    return;
                }
                if (response.data.content.length > 0) {
                    // 数据处理
                    this.leavelBill.userName = response.data.content[0].sUserName;
                    this.leavelBill.userDep = response.data.content[0].sDep;
                    this.leavelBill.userId = response.data.content[0].sUserNo;
                    this.leavelBill.startTime = response.data.content[0].dStartTime;
                    this.leavelBill.endTime = response.data.content[0].dEndTime;
                    this.leavelBill.days = response.data.content[0].iDays;
                    this.leavelBill.leaveReason = response.data.content[0].sReason;
                }
            });
            let taskParam = {
                taskId: this.editItem.taskId
            };
            if (taskParam.taskId != '' && taskParam.taskId != 'undefined') {
                Api.findTask(JSON.stringify(taskParam), response => {
                    // if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    //     this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    //     return;
                    // }
                    // if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    //     this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    //     this.$log.error('/activitiDemo/findTask', response.data.statusMessage);
                    //     return;
                    // }
                    if (response.data.content.length > 0) {
                        this.leavelBill.taskDefKey = response.data.content[0].taskKey;
                    }
                    if ('check2' === this.leavelBill.taskDefKey) {
                        //---------------------code
                        this.submitShow = true;
                        this.rejectShow = false;
                        this.returnShow = true;
                        this.commentEdit = false;
                    } else if ('check1' === this.leavelBill.taskDefKey) {
                        //---------------------code
                        this.submitShow = true;
                        this.rejectShow = false;
                        this.returnShow = true;
                        this.commentEdit = false;
                    } else if ('HR' === this.leavelBill.taskDefKey) {
                        //---------------------code
                        this.submitShow = true;
                        this.rejectShow = false;
                        this.returnShow = false;
                        this.commentEdit = true;
                    } else if ('apply' === this.leavelBill.taskDefKey) {
                        //---------------------code
                        this.submitShow = true;
                        this.rejectShow = false;
                        this.returnShow = false;
                        this.commentEdit = true;
                    }
                });
            }

            let hisTaskParam = {
                processId: this.editItem.processId,
                isFinished: true
            };
            Api.findHisTask(JSON.stringify(hisTaskParam), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('/activitiDemo/findHisTask', response.data.statusMessage);
                    return;
                }
                let tableRows = response.data.content;
                for (let i = 0; i < tableRows.length; i++) {
                    if (tableRows[i].comments.length > 0) {
                        tableRows[i].comment = tableRows[i].comments[0].message;
                    }
                }
                this.tableData = tableRows;
            });

            let proParam = {
                proInsId: this.editItem.processId
            };
            Api.findProIns(JSON.stringify(proParam), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('/activitiDemo/findProIns', response.data.statusMessage);
                    return;
                }
                if (response.data.content.length > 0) {
                    this.leavelBill.applyUserId = response.data.content[0].applyUserId;
                    this.leavelBill.proDefKey = response.data.content[0].proDefKey;
                }
            });
            if (this.sIdDisabled) {
                this.btnShow = false;
            }
        },
        //拒绝
        btnReturn() {
            this.leavelBill.isPass = false;
            this.leavelBill.userId = sessionStorage.getItem('userId');
            let param = this.leavelBill;
            Api.completeOrRefuse(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    return;
                }
                this.loading = false;
                // this.dialogLeaveBillClose();
                this.submitShow = false;
                this.rejectShow = false;
                this.returnShow = false;
                this.commentEdit = true;
                this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.RETURN_SUCCESS') });
            });
        },
        //撤回任务
        reject() {
            this.leavelBill.isPass = false;
            this.leavelBill.userId = null;
            let param = this.leavelBill;
            param.userId = null;
            this.loading = true;
            this.operEdit = true;
            Api.completeOrRefuse(JSON.stringify(param), response => {
                this.operEdit = false;
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    return;
                }
                // this.dialogLeaveBillClose();
                if (response.data.content.length > 0) {
                    this.leavelBill.taskId = response.data.content[0].taskId;
                }
                this.loading = false;
                this.submitShow = true;
                this.rejectShow = false;
                this.returnShow = false;
                this.commentEdit = true;
            });
        },
        //流程递转
        toOtherPer() {
            let param = this.leavelBill;
            this.loading = true;
            this.operEdit = true;
            Api.toOtherPer(JSON.stringify(param), response => {
                this.loading = false;
                this.operEdit = false;
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    return;
                }
                this.dialogLeaveBillClose();
                // if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                //     this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                //     this.$log.error('/device/saveDevice', response.data.statusMessage);
                //     return;
                // }
                // this.$util.toRouter('workflow_approval_manager_menu');
                // sessionStorage.setItem('leftMenuIndexId', 'workflow_approval_manager_menu');
            });
        },
        // 初始化类型下拉框
        initSelect() {
            // if (this.editItem.taskDefinitionKey == 'check1') {
            //     this.group = 'group2';
            //     let groupParam = {
            //         id: this.group,
            //         name: '',
            //         type: ''
            //     };
            //     Api.queryGroupInfoList(JSON.stringify(groupParam), response => {
            //         this.userIdList = response.data.content;
            //     });
            // } else {
            //     this.userIdEdit = true;
            //     this.leavelBill.userId = 'admin'; //设置默认值
            // }
            let param = {
                isNeedPage: false
            };
            // Api.queryGroupInfoList(JSON.stringify(groupParam), response => {
            //     this.userIdList = response.data.content;
            // });
            Api.queryTemplate(JSON.stringify(param), response => {
                this.leaveBillTypeList = response.data.content;
            });
        },
        btnCancel() {
            this.$emit('dialogLeaveBillClose');
        },
        // 关闭窗口之前需要调用的方法
        dialogLeaveBillClose() {
            this.$emit('dialogLeaveBillClose');
            this.dialogLeaveBillVisible = false;
        }
    }
};
</script>
